import axios from 'axios'; // 引入axios
import {
  Message
} from 'element-ui'
import Vue from 'vue';


import Qs from 'qs'
import router from "../router/index.js"

let baseURL = "https://gateway.lanchongyundong.com";
console.log("env:"+process.env.NODE_ENV);
if (process.env.NODE_ENV == "development") {
  //baseURL = "https://gateway.lanchongyundong.com";
  //baseURL = "https://dev-gateway.lanchongyundong.com";
  baseURL = "https://uat-gateway.lanchongyundong.com";
 //  baseURL = "http://192.168.0.101:9999";
  //  baseURL = "http://192.168.0.108:9999";
}else if (process.env.NODE_ENV == "uat") {
  baseURL = "https://uat-gateway.lanchongyundong.com";
}
export const development = baseURL; //测试环境
axios.defaults.baseURL = development
// 请求超时 请求头
axios.defaults.timeout = 50000000;

axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';


// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = window.localStorage['Authorization']; //token存储在浏览器
    token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    return Promise.error(error);
  })
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  localStorage.removeItem("Authorization");
  localStorage.removeItem('userName');
  router.push({
    path: "/login"
  });
}

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response.data.errorCode)
    if (response.data.errorCode === 0) {
      return Promise.resolve(response)
    } else {
      if (response.data.errorCode == 401) {
        localStorage.removeItem("Authorization");
        localStorage.removeItem('userName');
        window.location.href = "/";
        return;
      } else {
        // console.log('相应拦截器')
        return Promise.reject(response)
      }
    }
  },
  // 服务器状态码不是200的情况
  error => {
    // console.log(err,'err')
    if (error.data.errorCode) {
      switch (error.data.errorCode) {

        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。

        case 401:
          toLogin();
          break;
        // 403 token过期
        // 跳转登录页面
        case 403:
          Message({
            content: '登录过期，请重新登录',
            duration: 1
          })
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          toLogin();
          break
        // 404请求不存在
        case 404:
          Message({
            content: '网络请求不存在',
            duration: 1
          })
          break
        // 其他错误，直接抛出错误提示
        // default:
        //   Message({
        //     content: error.response.data.message,
        //     duration: 1.5
        //   })
        //   toLogin();
      }
    }
    return Promise.reject(error.response)
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
      Message({
        message: err.data.msg,
        type: 'error'
      });
    })
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        resolve(err.data)
        // Message({
        //   message: err.data.msg,
        //   type: 'error'
        // });
      })
  });
}

/**
 * post方法，参数序列化
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function qspost (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, Qs.stringify(params))
      .then(res => {
        resolve(res.data);
        //  Loading.service(true).close();
        //  Message({message: ‘请求成功‘, type: ‘success‘});
      })
      .catch(err => {
        reject(err.data)
        Message({
          message: err.data.msg,
          type: 'error'
        });
      })
  });
}


/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put (url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
        Message({
          message: err.data.msg,
          type: 'error'
        });
      })
  });
}


/**
 * delete
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletefn (url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, params)
      .then(res => {
        resolve(res.data);
        // Loading.service(true).close();
        //  Message({message: ‘请求成功‘, type: ‘success‘});
      })
      .catch(err => {
        reject(err.data)
        // Loading.service(true).close();
        Message({
          message: err.data.msg,
          type: 'error'
        });
      })
  });
}



// WEBPACK FOOTER //
// ./src/request/http.js